// Unified hook: returns { breakpoint, windowWidth } for responsive logic
import { useState, useEffect } from 'react';

export default function useBreakpoint() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  let breakpoint = 'sm';
  if (windowWidth >= 1500) breakpoint = 'xl';
  else if (windowWidth >= 1200) breakpoint = 'lg';
  else if (windowWidth >= 800) breakpoint = 'md';
  return { breakpoint, windowWidth };
}
